import { el } from "../lib/dom";
import { sectionCover } from "../lib/sectionCover";
import { photos } from "../content/photos.generated";

interface Guesthouse {
  name: string;
  /** Short subtitle shown above the name in uppercase tracking */
  area: string;
  url: string;
  /** Label of the destination platform, used in the CTA */
  source: "Google Maps" | "Booking.com";
}

const guesthouses: Guesthouse[] = [
  {
    name: "TangleWood Nature Estate",
    area: "Naby Potchefstroom",
    url: "https://www.booking.com/hotel/za/tanglewood-nature-estate.en-gb.html",
    source: "Booking.com",
  },
  {
    name: "River View Guesthouse",
    area: "Potchefstroom",
    url: "https://www.booking.com/hotel/za/river-view.en-gb.html",
    source: "Booking.com",
  },
  {
    name: "Opstal Gastehuis",
    area: "Potchefstroom",
    url: "https://www.booking.com/hotel/za/opstal-gastehuis.en-gb.html",
    source: "Booking.com",
  },
  {
    name: "2 Owls Guest House",
    area: "Potchefstroom",
    url: "https://www.booking.com/hotel/za/2owlsguesthouse.en.html",
    source: "Booking.com",
  },
  {
    name: "The Feather Hill Boutique",
    area: "Potchefstroom",
    url: "https://www.booking.com/hotel/za/the-feather-hill-boutique.en-gb.html",
    source: "Booking.com",
  },
  {
    name: "Potch Manor",
    area: "Potchefstroom",
    url: "https://www.booking.com/hotel/za/potch-manor.en-gb.html",
    source: "Booking.com",
  },
];

export function renderAccommodation(root: HTMLElement) {
  const page = el("section", { class: "page", id: "akkommodasie" });

  page.appendChild(
    sectionCover({
      title: "Akkommodasie",
      photo: photos.gallery[9] ?? photos.gallery[0] ?? null,  // IMG_4730
    }),
  );

  const content = el("div", { class: "page__content" });

  const grid = el("div", { class: "lodging-grid" });
  for (const g of guesthouses) {
    const card = el(
      "a",
      {
        class: "lodging-card",
        href: g.url,
        target: "_blank",
        rel: "noopener noreferrer",
        "data-cursor-label": "Bespreek",
      },
    );
    card.appendChild(el("p", { class: "lodging-card__area" }, g.area));
    card.appendChild(el("h3", { class: "lodging-card__name" }, g.name));
    card.appendChild(
      el(
        "p",
        { class: "lodging-card__cta" },
        el("span", {}, `Sien op ${g.source}`),
        el("span", { class: "lodging-card__arrow", "aria-hidden": "true" }, "→"),
      ),
    );
    grid.appendChild(card);
  }
  content.appendChild(grid);
  page.appendChild(content);
  root.appendChild(page);
}
